export default __webpack_public_path__ + "locales/bg/Ldap.json?hash=c771b4873e3e2f24d78cbc431149435e";